<template>
  <main v-if="news">
    <h1 class="news-title">{{ news.newTitle }}</h1>
    <div class="news-info">
      <span class="author">作者：{{ news.author }}</span>
      <span class="date">{{ dateFormat(news.createTime) }}</span>
      <span class="count">阅读数：{{ news.clickCount }}</span>
    </div>
    <div class="news-content">
      <div v-html="news.newContent"></div>
    </div>
  </main>
  <loading :options="loadOption" v-else></loading>

  <preview
    v-if="imgList.length && previewing"
    @close="closePreview"
    :imgList="imgList"
    :currentIndex="currentIndex"
  ></preview>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  onMounted,
  ref,
  watch,
  nextTick,
  inject,
  onUpdated
} from "vue";

import Loading from "@/components/UI/Loading";
import Preview from "@/components/UI/Preview";
import { ImgItem } from "@/components/UI/Preview/src/Preview.vue";
import { useRoute, useRouter } from "vue-router";
import $, { param } from "jquery";
import axios from "@/api/axios";
import dateFormat from "@/utils/dateFormat";
import qs from "qs";
import Toast from "@/components/UI/Toast";
import asyncLoadJs from "@/hooks/useAsyncLoadJs";
import Modal from "@/components/UI/Modal";

export default defineComponent({
  name: "about",
  components: {
    Loading,
    Preview,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const id = ref(route.query.newsid);
    const news = ref(null);
    const loading = ref(true);

    function getRenderData(id: string) {
      news.value = null;
      loading.value = true;
      axios
        .get("/M/News/NewsDetail/" + id)
        .then(res => {
          if (res.data.success) {
            const data = res.data.obj;
            news.value = data;
            document.title = data.newTitle + "-北纳标物网";
            loading.value = false;
            route.meta.title = data.newTitle;
            route.meta.content.keywords = data.newskey;
            route.meta.content.description = data.newssummary;
            asyncLoadJs(
              "//imgcache.qq.com/open/qcloud/video/tcplayer/lib/hls.min.0.8.8.js",
              "about"
            ).then(() => {
              asyncLoadJs(
                "//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.min.js",
                "about"
              ).then(() => {
                nextTick(() => {
                  data.newContent.match(/<script.*?>([\s\S]+?)<\/script>/gim);
                  eval(RegExp.$1);
                });
              });
            });
          } else {
            Toast({
              type: "error",
              title: res.data.msg
            });
          }
        })
        .catch(err => {
          console.log(err);
          loading.value = false;
        });
    }

    getRenderData(id.value as string);
    const loadOption = {
      text: "加载中...",
      color: "#df0024",
      textColor: "#df0024"
    };
    //  preview picture
    const imgList = reactive<ImgItem[]>([]);
    const currentIndex = ref(0);
    const previewing = ref(false);
    function getSrcIndex(src: string, array: JQuery<HTMLElement>): number {
      let index = 0;
      array.each(function(i, item) {
        if ($(this).prop("src") == src) {
          index = i;
        }
      });
      return index;
    }

    onMounted(() => {
      $(document).on("click", ".news-content img", function(e: Event) {
        const src = $(this).prop("src");
        currentIndex.value = getSrcIndex(src, $(".news-content img"));
        previewing.value = true;
      });
    });
    function closePreview() {
      previewing.value = false;
    }
    watch(
      () => {
        return news.value;
      },
      () => {
        nextTick(() => {
          const imgDom = document.querySelectorAll(".news-content img");
          imgDom.forEach(img => {
            imgList.push({ src: img.getAttribute("src") as string });
          });
        });
      }
    );

    watch(
      [
        () => {
          return route.query;
        },
        () => {
          return route.params;
        }
      ],
      (to, from) => {
        console.log(to, from);
        // 避免登录时触发页面刷新
        if (to[0].newsid && !from[1].valid) {
          getRenderData(to[0].newsid as string);
        }
      }
    );
    const my = inject("userInfo") as any;
    return {
      news,
      dateFormat,
      loadOption,
      imgList,
      previewing,
      currentIndex,
      loading,
      closePreview,
      id,
    };
  }
});
</script>

<style lang="scss" scoped>
main {
  padding-bottom: 70px;
  text-align: center;
}
.news-title {
  color: #444444;
  font-size: 16px;
  font-weight: bold;
  width: 355px;
  margin: 0 auto;
  padding-bottom: 10px;
  padding-top: 20px;
}

.news-info {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
}

.author,
.date {
  margin-right: 20px;
}

.count {
  margin-right: 0;
}

.news-content {
  width: 355px;

  margin: 0 auto;
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: justify;
  font-size: 16px;
  color: #666666;
  line-height: 25px;
  overflow: hidden;

  border-bottom: 1px solid #eee;
  :deep(p) {
    margin: 1em 0;
    word-break: break-word;
  }
  :deep(a) {
    color: #3498db;
  }
  :deep(video) {
    width: 100% !important;
  }
  :deep(table) {
    width: 100% !important;
  }
  :deep(img) {
    width: 100% !important;
    height: auto !important;
  }
  :deep(table) {
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
  }
  :deep(.articleVideo) {
    width: 8.933rem;
    height: 5.013rem;
    margin: 0 auto;
  }
}

.author a {
  color: rgb(61, 194, 214);
  font-size: 14px;
}
</style>
